import { normaliseProductConfirmationInputField } from "src/helpers";
import { IdGenerator, ObjectCompare } from "src/utils";
import {
  POProductConfirmationInputField,
  UpdatePurchaseOrderConfirmationFormData,
  PostPurchaseOrderConfirmationRequestBody,
  PurchaseOrder
} from "src/types";

export class UpdatePurchaseOrderConfirmationMapper {
  public static initUpdatePurchaseOrderConfirmationFormData(): UpdatePurchaseOrderConfirmationFormData {
    return {
      purchaseOrderId: "",
      productConfirmations: [],
      estShipDate: "",
      estDeliveryDate: "",
      estCollectionDate: "",
      additionalInfo: "",
      cancellationReason: ""
    };
  }

  public static productConfirmationFormDataFromPurchaseOrder(
    purchaseOrder: PurchaseOrder
  ): POProductConfirmationInputField[] {
    if (!purchaseOrder.products) {
      return [];
    }

    return purchaseOrder.products.map((product) => {
      const confirmationProduct = purchaseOrder.confirmationDetails?.products?.find(
        (confirmation) => confirmation.productId === product.id
      );
      return {
        fieldId: IdGenerator.generateUniqueElementId(product.id),
        productId: product.id,
        confirmedQty: confirmationProduct?.confirmedQty?.toString() ?? "",
        estRestockDate: confirmationProduct?.estRestockDate ?? "",
        isDiscontinued: confirmationProduct?.isDiscontinued ?? false,
        orderQty: product.quantity.toString(),
        productName: product.name,
        productBarcode: product.barcode ?? "",
        productExtraInfo: product.extraInfo ?? "",
        productSize: product.size ?? "",
        unitCost: product.unitCost
      };
    });
  }

  public static updatePurchaseOrderConfirmationFormDataFromPurchaseOrder(
    purchaseOrder: PurchaseOrder
  ): UpdatePurchaseOrderConfirmationFormData {
    return {
      purchaseOrderId: purchaseOrder.id,
      productConfirmations:
        UpdatePurchaseOrderConfirmationMapper.productConfirmationFormDataFromPurchaseOrder(purchaseOrder),
      estShipDate: purchaseOrder.confirmationDetails?.estShipDate ?? "",
      estDeliveryDate: purchaseOrder.confirmationDetails?.estDeliveryDate ?? "",
      estCollectionDate: purchaseOrder.confirmationDetails?.estCollectionDate ?? "",
      additionalInfo: purchaseOrder.additionalInfo?.confirmationNote?.body ?? "",
      cancellationReason: purchaseOrder.cancellationDetails?.cancellationReason ?? ""
    };
  }

  public static updatePurchaseOrderConfirmationRequestBodyFromFormData(
    formData: UpdatePurchaseOrderConfirmationFormData,
    initialFormData?: UpdatePurchaseOrderConfirmationFormData
  ): PostPurchaseOrderConfirmationRequestBody {
    const productConfirmationsNoChange = ObjectCompare.isEqual(
      initialFormData?.productConfirmations,
      formData.productConfirmations
    );

    const normalisedProductConfirmations = productConfirmationsNoChange
      ? undefined
      : formData.productConfirmations.map(normaliseProductConfirmationInputField);

    const normalisedEstShipDate =
      initialFormData?.estShipDate === formData.estShipDate ? undefined : formData.estShipDate;

    const normalisedEstDeliveryDate =
      initialFormData?.estDeliveryDate === formData.estDeliveryDate ? undefined : formData.estDeliveryDate;

    const normalisedEstCollectionDate =
      initialFormData?.estCollectionDate === formData.estCollectionDate ? undefined : formData.estCollectionDate;

    const normalisedConfirmationNoteBody = !initialFormData?.additionalInfo
      ? formData.additionalInfo || undefined
      : formData.additionalInfo || null;

    return {
      products: normalisedProductConfirmations,
      estShipDate: normalisedEstShipDate,
      estDeliveryDate: normalisedEstDeliveryDate,
      estCollectionDate: normalisedEstCollectionDate,
      confirmationNoteBody: normalisedConfirmationNoteBody
    };
  }
}
